<template>
  <div class="home">
    <HeaderSponsor class="d-none d-md-flex" />
    <HeaderSponsorPortable class="d-flex d-md-none" />

    <div class="frame-782">
      <div class="container">
        <div class="find-investors-and-succeed-your-fundraisingthanks-to-ideas-fund-x">
        Find investors and succeed your fundraising<br />
        thanks to IdeasFundX
      </div>
      <span class="ideas-fund-xis-for-companies-and-series-aand-bstartups-that-areraising-1-million-usd-around-the-world">
        IdeasFundX is for companies and series A and B startups that are<br />
        raising +1 million USD around the world
      </span>
      </div>
    </div>

    <div class="container get-started-1 mt-5 pt-4 d-flex flex-column justify-content-center align-items-center">
      <div class="less-than-3-of-the-dealflow-pass-the-2-nd-meeting-with-vcs-ideas-fund-xrelieves-thispain-that-many-series-aand-blevel-companies-face-byeasing-the-process-of-securing-funding-from-trusted-investors-our-ai-driven-matchmaking-tools-help-companies-pass-the-screening-stepand-get-introduced-to-relevant-investors">
        Less than 3% of the dealflow pass the 2nd meeting with VCs.<br />
        IdeasFundX relieves this “pain” that many series A and B level companies face by<br />
        easing the process of securing funding from trusted investors.<br />
        <br />
        Our AI-driven matchmaking tools help companies pass the screening step<br />
        and get introduced to relevant investors.
      </div>
      <div class="d-flex justify-content-center align-items-center frame-776 text-center mt-4">
        <span class="get-started-2">
          GET STARTED
        </span>
      </div>
    </div>

    <div class="container how-it-works mt-5">
      <h2 class="linear-gradient-text">How it works</h2>
      <div class="mt-5">
        <div class="thumb thumb-1 text-start d-flex justify-content-center align-items-center gap-5">
          <h1 class="number-text-one">1.</h1>
          <img
            alt="Ideasfundx h-1"
            src="../assets/img/h-1.svg"
            width="150"
            height="150"
          />
          <div class="">
            <h4 class="site-text">Create your Company Profile</h4>
            <h5 class="mt-3"><b>Present your company</b></h5>
            <div class="w-50 w-lg-50" style="color: gray">
              Companies are Seed and Serie A+ startups and companies in fast growth who are looking 
              for + USD $1 Million of funding
            </div>
          </div>
        </div>

        <div class="text-start d-flex flex-row-reverse mt-4">
          <div class="thumb thumb-1 d-flex justify-content-end align-items-center gap-5 w-50 w-md-50">
            <h1 class="number-text-one">2.</h1>
            <img
              alt="Ideasfundx h-1"
              src="../assets/img/h-2.svg"
              width="150"
              height="150"
            />
            <div class="text-start">
              <h4 class="site-text">Pass the qualification review</h4>
            <h5 class="mt-3"><b>Complete your application</b></h5>
            <div style="color: gray">
              Describe your busine, growth plan and your funding needs... Get practical feedback to maximize your chance to convince investors Be shortlisted among the qualified dealflow
            </div>
            </div>
          </div>
        </div>

        <div class="thumb thumb-1 text-start d-flex justify-content-center align-items-center gap-5 mt-4 w-75 w-md-50">
          <h1 class="number-text-one">3.</h1>
          <img
            alt="Ideasfundx h-1"
            src="../assets/img/h-3.svg"
            width="150"
            height="150"
          />
          <div class="">
            <h4 class="site-text">Start discussing with investors</h4>
            <h5 class="mt-3"><b>Investors picks up their own choice of deals and access to more information about each deal they have selected.</b></h5>
            <div class="w-50 w-lg-50" style="color: gray">
              After reviewing the information available, they contact the company to start the discussion.
            </div>
          </div>
        </div>

        <div class="text-start d-flex flex-row-reverse mt-4">
          <div class="thumb thumb-1 d-flex justify-content-end align-items-center gap-5 w-50 w-md-50">
            <h1 class="number-text-one">4.</h1>
            <img
              alt="Ideasfundx h-1"
              src="../assets/img/h-4.svg"
              width="150"
              height="150"
            />
            <div class="text-start">
              <h4 class="site-text">Be introduced to relevant investors</h4>
            <h5 class="mt-3"><b>Our matching algorithms and filtering programs select relevant investors for your company.</b></h5>
            <div style="color: gray">
              Investors receive qualified dealflow matching their preferences and investment strategies.
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="body-how-much border">
      <div class="body-how-much-content">
        <h2 class="how-it-works-title">How much</h2>
        <div class="sub-title text-center">
          Payment staggered according to the progress of the funding process
        </div>

        <div class="how-much-hum d-flex justify-content-start align-items-center mt-4">
          <div class="number-text-one-format d-flex justify-content-center align-items-center">1</div>
          <span class="description text-start">
            When you apply to IdeasFundX, you’re paying a fixed fee of 0.1%
            of the amount of your company’s funding need to go through <br />
            the qualification process and be referred to investors.
          </span>
        </div>

        <div class="how-much-hum d-flex justify-content-start align-items-center mt-4">
          <div class="number-text-one-format d-flex justify-content-center align-items-center">2</div>
          <span class="description text-start">
            After being qualified, to recommend your company to investors,
            you should subscribe <br /> a yearly membership of $490 excl. tax.
          </span>
        </div>
        
        <div class="how-much-hum d-flex justify-content-start align-items-center mt-4">
          <div class="number-text-one-format d-flex justify-content-center align-items-center">3</div>
          <span class="description text-start">
            If the negotiation is successful and the investment agreement is signed, <br /> IdeasFundX takes a success fee of 4% of the investment.
          </span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import HeaderSponsor from "@/components/HeaderSponsor.vue";
import HeaderSponsorPortable from "@/components/HeaderSponsorPortable.vue";

export default {
  name: "Home",
  components: {
    HeaderSponsor,
    HeaderSponsorPortable
  },
};
</script>
<style scoped>
  @font-face {
    font-family: "Inter-light";
    src: url("../assets/fonts/inter/Inter-Light.ttf");
  }
  @font-face {
    font-family: 'Inter';
    src: url("../assets/fonts/inter/Inter-Medium.ttf");
  }
  @font-face {
    font-family: 'Jolly Lodger';
    src: url("../assets/fonts/JollyLodger-Regular.ttf");
  }
  * {
    font-family: 'Inter-light', sans-serif;
  }
  .number-text-one {
    overflow-wrap: break-word;
    font-family: 'Jolly Lodger', sans-serif;
    font-weight: 400;
    font-size: 80px;
    background: linear-gradient(180deg, #00A8C3, #24C091);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
  }
  .number-text-one-format {
    border-radius: 10px;
    background: linear-gradient(180deg, #027D90, #0393AA);
    position: relative;
    gap: 10px;
    padding: 8px 1px 7px 0;
    width: 67px;
    height: fit-content;
    box-sizing: border-box;
    overflow-wrap: break-word;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 48px;
    color: #FFFFFF;
  }
  .thumb {
    gap: 15px;
  }
  .site-text {
    background: linear-gradient(180deg, #00A8C3, #24C091);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    font-family: 'Inter', sans-serif;
  }

  .frame-782 {
    background: linear-gradient(180deg, #00A8C3, #24C091);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 77px 0 79px 0;
    width: 100%;
    box-sizing: border-box;
  }
  .find-investors-and-succeed-your-fundraisingthanks-to-ideas-fund-x {
    margin-bottom: 44px;
    display: inline-block;
    text-align: center;
    overflow-wrap: break-word;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 48px;
    color: #FFFFFF;
  }
  .ideas-fund-xis-for-companies-and-series-aand-bstartups-that-areraising-1-million-usd-around-the-world {
    margin-left: 7px;
    text-align: center;
    overflow-wrap: break-word;
    font-family: 'Inter-light', sans-serif;
    font-weight: 500;
    font-size: 24px;
    color: #FFFFFF;
  }
  .less-than-3-of-the-dealflow-pass-the-2-nd-meeting-with-vcs-ideas-fund-xrelieves-thispain-that-many-series-aand-blevel-companies-face-byeasing-the-process-of-securing-funding-from-trusted-investors-our-ai-driven-matchmaking-tools-help-companies-pass-the-screening-stepand-get-introduced-to-relevant-investors {
    margin-bottom: 29px;
    display: inline-block;
    text-align: center;
    overflow-wrap: break-word;
    font-family: 'Inter-light', sans-serif;
    font-weight: 500;
    font-size: 24px;
    color: #080707;
  }
  .frame-776 {
    border-radius: 5px;
    background: linear-gradient(90deg, #00A8C3, #24C091);
    margin-left: 1px;
    display: flex;
    padding: 20px 0;
    width: 285px;
    box-sizing: border-box;
  }
  .get-started-2 {
    overflow-wrap: break-word;
    font-weight: 700;
    font-size: 18px;
    color: #FFFEFE;
  }
  .linear-gradient-text {
    position: relative;
    display: inline-block;
    overflow-wrap: break-word;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 60px;
    background: linear-gradient(90deg, #00A8C3, #24C091);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
  }
  .body-how-much {
    background: #00A8C3;
    transform: rotate(-4deg);
    position: relative;
    margin-top: 52px;
    width: 150vw;
    left: -35px;
    box-sizing: border-box;
    padding: 120px;
  }
  .body-how-much-content {
    transform: rotate(4deg);
    width: 100vw;
  }
  .how-it-works-title {
    position: relative;
    display: inline-block;
    overflow-wrap: break-word;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 60px;
    color: #fff;
    background-clip: text;
    -webkit-background-clip: text;
  }
  .sub-title {
    font-weight: 700;
    font-size: 20px;
    color: #fff;
  }
  .how-much-hum {
    gap: 30px;
  }
  .how-much-hum .description {
    overflow-wrap: break-word;
    font-weight: 400;
    font-size: 32px;
    color: #FFFFFF;
  }
  
</style>
